import CompanyLogo from '../../CompanyLogo'
import styles from './Screener.module.scss'
import useCompanyLogo from '../hooks/useCompanyLogo'
import Button from '@mui/material/Button';
import { useGeneral } from '../../../context/general'
import { Typography } from '@mui/material'
import Spinner from "../../Spinner"
import Modal from '../../Modal'
import { useState } from 'react';

const CompanyDataCell = ({ticker, companyName,project}) => {
    const { handleCreateProjectAndOpen } = useGeneral()
    const [ modal, setModal ] = useState('')
    const handleCloseModal = () => setModal(false)
    const OpenModal = () => {
        setModal('Setting up project')
    }
    // const { url } = useCompanyLogo(ticker)

    const CreateNewProject = () =>{
        OpenModal()
        handleCreateProjectAndOpen(ticker)
        setTimeout(() => {
            setModal('')
          }, 10000);
    }
    
    return (<>
        <div className={styles['company-data-cell']}>
            {/* <CompanyLogo image={url && (url.image ?? '')} ticker={ticker} size={32} /> */}
            <Button variant="text" style={{color:'#dccb03'}} onClick={CreateNewProject}>{companyName}</Button>
        </div>

        <Modal open={!!modal} handleClose={handleCloseModal}>
            <div className="newsGraphModalContent">
                <Spinner hasText={false} />
                <Typography variant="h3">
                    {modal}
                </Typography>
            </div>
        </Modal> 
        </>
    )
}

export default CompanyDataCell